import React from "react";

import { Icon } from "@chakra-ui/react";
import {
  MdMap,
  MdGpsFixed,
  MdBook,
} from "react-icons/md";

import {
  FaUsers
} from "react-icons/fa6";

import ChipStats from "views/admin/chipstats";
import Logging from "views/admin/logging";
import UserBoard from "views/admin/addUsers";
import MainDashboard from "views/admin/default";
import SignIn from "views/auth/signIn";
import ForgotPassword from "views/auth/forgotPassword";
import ResetPassword from "views/auth/resetPassword";

const routes = [
  {
    name: "Beehive Live",
    layout: "/admin",
    path: "/default",
    icon: <Icon as={MdMap} width='20px' height='20px' color='inherit' />,
    component: MainDashboard,
  },
  {
    name: "Organisasjon",
    layout: "/admin",
    path: "/adduser",
    icon: (
      <Icon
        as={FaUsers}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: UserBoard,
    secondary: true,
  },
  {
    name: "Chipstatistikk",
    layout: "/admin",
    path: "/chipstats",
    icon: (
      <Icon
        as={MdGpsFixed}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: ChipStats,
    secondary: true,
  },
  {
    name: "Logging",
    layout: "/admin",
    path: "/logging",
    icon: (
      <Icon
        as={MdBook}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: Logging,
    secondary: true,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "/sign-in",
    component: SignIn,
    showInSidebar: false,
  },
  {
    name: "Glemt Passord",
    layout: "/auth",
    path: "/forgot-password",
    component: ForgotPassword,
    showInSidebar: false,
  },
  {
    name: "Endre Passord",
    layout: "/auth",
    path: "/reset-password",
    component: ResetPassword,
    showInSidebar: false,
  },
];

export default routes;
